<app-header></app-header>
<app-right-side></app-right-side>

<div *ngIf="isLoaderVisible" class="preloader js-preloader">
    <img src="assets/img/loader.webp">
</div>
<div class="container mt-2" [dir]="direction">
    <div class="row">
        <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="ui-block responsive-flex">
                <div class="ui-block-title">
                    <div class="h6 label-title" *ngIf="language != 'ar'" style="color:#3e758f"><i class="fad fa-trophy" style="color:#3e758f"></i>&nbsp;THE BEST (11) PLAYER / RANKING ANNUAL</div>
                    <div class="h6 label-title" style="float: right;" *ngIf="language == 'ar'"><i class="fad fa-trophy"></i>&nbsp;{{'ranking.ranking' | translate}}</div>
                    <div *ngIf="currentUser.success.user.id == 1 || currentUser.success.user.id == 5 || currentUser.success.user.id == 18 || currentUser.success.user.user_type_id == '1'">
                        <a routerLink="/add-ranking">
                            <img src="../../../assets/img/dashboard.webp" class="img-responsive img-fluid center" alt="Dashboard" style="width: 44px;"></a>
                    </div>
                </div>

            </div>
            <!-- <div *ngIf="awards.length === 0" class="ui-block-title">
                <h6 class="display-message"> Coming Soon End of Season 2020 </h6>
            </div> -->
        </div>


    </div>
</div>
<div class="container" [dir]="direction">
    <div class="row">
        <div *ngFor="let year of years" class="col col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
            <br>
            <div class="ui-block responsive-flex" style="background-color: #3e758f; color:#e4e4e4">
                <div class="ui-block-title">
                    
                    <div class="h6 label-title text-center" style="color:#fff" ><i class="fad fa-trophy"></i>&nbsp;{{year.id}} </div>

                </div>

            </div>
            <table *ngFor="let rank of ranking">
                <thead *ngIf="year.id == rank.yearOfRanking">
                    <tr>
                        <!-- <th>Name</th> -->
                    </tr>
                </thead>
                <tbody *ngIf="year.id == rank.yearOfRanking" style="border:1px solid #e4e4e4">
                    <tr style="padding: 15px; width: 100%; ">
                        <td style="padding: 15px; width: 70px; color:#3e758f; font-weight: 500; font-size: 25px;">{{rank.rank}}</td>
                        <td *ngIf="year.id == rank.yearOfRanking" style="padding: 15px; width:20%;">
                            <a href="javascript:void(0)"><img src="../../../../../assets/img/user.jpg" width="30px" class="avatar" alt="Avatar"> 
                            </a>
                        </td>
                        <td style="color:var(--text-color); font-weight: 500; width: 65%; font-size: 20px;">
                            {{rank.firstName}} {{rank.lastName}}<br>
                            <div *ngFor="let item of awards1" style="font-size: 10px;">
                            <span *ngIf="item.id == rank.award" style="color: #3e758f;">    
                                {{item.name}}
                            </span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        
    </div>
    <br><br>
</div>
